import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

interface ModalProps {
  show: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  headerRight?: React.ReactNode
  className?: string
}

export const Modal: React.FC<ModalProps> = ({
  show,
  onClose,
  title,
  children,
  size = 'md',
  headerRight,
  className
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [show])

  const sizeClass =
    size === 'xxl'
      ? 'modal-xxl'
      : size === 'xl'
        ? 'modal-xl'
        : size === 'lg'
          ? 'modal-lg'
          : size === 'sm'
            ? 'modal-sm'
            : ''

  return ReactDOM.createPortal(
    <div className={`modal-overlay ${show ? 'show' : ''}`} onClick={onClose}>
      <div
        className={`modal ${sizeClass} ${className || ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          {headerRight && <div className="modal-header-right">{headerRight}</div>}
          <button className="modal-close" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  )
}
